import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Submission } from 'src/app/model/paper';

/** Submissão com a marcação de seleção usada pelas listas de sessão. */
export interface SelectableSubmission extends Submission {
  selected?: Boolean;
}

/**
 * Lista de submissões de uma sessão: busca, contador e seleção por checkbox.
 *
 * Extraído da aba "Submissões" do `app-general-session-dialog` para ser usado
 * TAMBÉM no diálogo de adicionar submissões (card fantasma da aba
 * "Submissões V2"). Um componente só garante que os dois lugares mostrem
 * exatamente o mesmo conteúdo — e continuem iguais depois de mudanças.
 *
 * O componente NÃO carrega dados: recebe a lista pronta e escreve a seleção
 * direto em `submission.selected` (o mesmo objeto que o consumidor usa ao
 * salvar), emitindo `selectionChange` a cada alteração.
 */
@Component({
  selector: 'app-session-submissions-picker',
  templateUrl: './session-submissions-picker.component.html',
  styleUrls: ['./session-submissions-picker.component.scss'],
})
export class SessionSubmissionsPickerComponent {
  @Input() submissions: SelectableSubmission[] = [];
  /** Sessão em edição — define o agrupamento e o que fica desabilitado. */
  @Input() sessionId: number;
  /** Título da sessão por id, para a coluna "Sessão". */
  @Input() sessionTitleById = new Map<number, string>();

  /**
   * Mostra o contador "N de M selecionadas" ao lado da busca. Desligado no
   * diálogo de adicionar, onde a busca fica centralizada e sozinha.
   */
  @Input() showCount = true;

  @Output() selectionChange = new EventEmitter<void>();

  searchText = '';

  /** A submissão está alocada em OUTRA sessão — não pode ser marcada aqui. */
  isInOtherSession(submission: SelectableSubmission): boolean {
    return !!submission.session && (submission.session as unknown as number) !== this.sessionId;
  }

  /** Título da sessão onde a submissão está alocada (vazio se livre). */
  sessionTitleOf(submission: SelectableSubmission): string {
    if (!submission.session) { return ''; }
    return this.sessionTitleById.get(submission.session as unknown as number) || '';
  }

  get selectedCount(): number {
    return (this.submissions || []).filter(item => item.selected).length;
  }

  get totalCount(): number {
    return (this.submissions || []).length;
  }
}
